import "./App.css";
import { router } from "./Routes/Router";
import { RouterProvider } from "react-router-dom";

function App({ children }) {
  return <RouterProvider router={router}>{children}</RouterProvider>;
}

export default App;
